if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.viewer = this.querySelector('[id^="GalleryViewer"]');
        this.thumbnails = this.querySelector('[id^="GalleryThumbnails"]');
        if (!this.viewer || !this.thumbnails) return;

        // Safari detection
        this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || 
                       /iPad|iPhone|iPod/.test(navigator.userAgent);

        this.thumbnailButtons = Array.from(this.thumbnails.querySelectorAll('[data-target]'));

        // Initial fade-in for the active image
        let activeMedia = this.viewer.querySelector('.is-active img');
        let activeMediaItem = this.viewer.querySelector('.is-active');
        let activeThumbnail = this.thumbnails.querySelector('.is-active');
        if (!activeMediaItem) {
          // No active media, set the first as active
          activeMediaItem = this.viewer.querySelector('[data-media-id]');
          if (activeMediaItem) activeMediaItem.classList.add('is-active');
        }
        if (!activeThumbnail && activeMediaItem) {
          // Set corresponding thumbnail as active
          const mediaId = activeMediaItem.getAttribute('data-media-id');
          const thumb = this.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          if (thumb) thumb.classList.add('is-active');
          }
        activeMedia = activeMediaItem ? activeMediaItem.querySelector('img') : null;
        if (activeMedia) this.fadeInImage(activeMedia);

        // Fade-in for all thumbnail images
        this.thumbnails.querySelectorAll('.media-gallery__thumbnail > img').forEach(img => this.fadeInImage(img));

        this.thumbnailButtons.forEach(thumbnail => {
          thumbnail.addEventListener('click', () => this.setActiveMedia(thumbnail.dataset.target));
        });

        if (this.thumbnailButtons.length > 1) {
          this.handleKeyDown = this.handleKeyDown.bind(this);
          document.addEventListener('keydown', this.handleKeyDown);
        }
      }

      disconnectedCallback() {
        if (this.handleKeyDown) {
          document.removeEventListener('keydown', this.handleKeyDown);
        }
      }

      handleKeyDown(event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        if (event.defaultPrevented) return;
        if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;

        const rect = this.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;

        const activeIndex = this.thumbnailButtons.findIndex((button) => button.classList.contains('is-active'));
        if (activeIndex === -1) return;

        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextIndex = (activeIndex + direction + this.thumbnailButtons.length) % this.thumbnailButtons.length;
        const nextThumbnail = this.thumbnailButtons[nextIndex];

        this.setActiveMedia(nextThumbnail.dataset.target, { scrollThumbnail: true });
        event.preventDefault();
      }

      setActiveMedia(mediaId, options = {}) {
        const thumbnail = this.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        const newMedia = this.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        if (!newMedia || !thumbnail) return;

        // Deactivate all
        this.viewer.querySelectorAll('.is-active').forEach(el => el.classList.remove('is-active'));
        this.thumbnails.querySelectorAll('.is-active').forEach(el => el.classList.remove('is-active'));

        // Pause/reset any active video or deferred-media
        this.viewer.querySelectorAll('.media-gallery__item').forEach(item => {
          const video = item.querySelector('video');
          if (video && !video.paused) {
            video.pause();
          }

          const deferred = item.querySelector('deferred-media');
          if (deferred) {
            const iframe = deferred.querySelector('iframe');
            if (iframe) iframe.remove();
            const poster = deferred.querySelector('.deferred-media__poster');
            if (poster) poster.classList.remove('hidden');
          }
        });

        newMedia.classList.add('is-active');
        thumbnail.classList.add('is-active');

        if (options.scrollThumbnail) {
          thumbnail.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }

        const img = newMedia.querySelector('img');
        const deferredMedia = newMedia.querySelector('deferred-media');
        const video = newMedia.querySelector('video');

        if (deferredMedia) {
          // The deferred-media component will handle the loading when user clicks
        } else if (video) {
          video.addEventListener('loadeddata', () => {
            video.classList.add('loaded');
          }, { once: true });
        } else if (img) {
          this.fadeInImage(img);
        }
      }

      fadeInImage(img) {
        img.classList.remove('loaded');
        if (img.complete && img.naturalWidth !== 0) {
          requestAnimationFrame(() => img.classList.add('loaded'));
        } else {
          img.addEventListener('load', () => img.classList.add('loaded'), { once: true });
        }
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', function() {
  // Safari detection
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || 
                   /iPad|iPhone|iPod/.test(navigator.userAgent);

  // Initialize deferred-media elements for Safari
  if (isSafari) {
    document.querySelectorAll('.deferred-media').forEach(deferred => {
      // Ensure proper positioning for Safari
      deferred.style.position = 'relative';
      deferred.style.width = '100%';
      deferred.style.height = '100%';
    });
  }
});
